import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class BackNavigationService {
  constructor(
    private readonly location: Location,
    private readonly router: Router,
  ) {}

  back(fallbackUrl = '/'): void {
    if (window.history.length > 1) {
      this.location.back();
      return;
    }

    void this.router.navigateByUrl(fallbackUrl);
  }
}
